var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-view-style01"},[_c('img',{staticClass:"empty-cover",attrs:{"src":_vm.$images.gensee_empty_view_bg_01,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"empty-text"},[_vm._v("暂时都在这里啦～")])])
}
var staticRenderFns = []

export { render, staticRenderFns }